module.exports = __webpack_public_path__ + "static/media/Platformicon03.8a167ee7.png";